var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLoginIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 16",
    fill: "#fff",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.978 13.983c2.076-.353 3.937-2.015 4.633-4.12.274-.816.362-2.277.206-3.144-.4-2.207-2.243-4.182-4.388-4.756-.754-.202-2.253-.202-2.968-.01-1.31.35-2.74 1.347-2.74 1.902 0 .312.392.766.666.766.108 0 .333-.1.52-.252C6.324 3.3 7.656 3 9.037 3.36c1.773.474 3.085 1.925 3.408 3.78.392 2.298-1.087 4.676-3.28 5.3-.97.272-2.194.17-3.046-.242-.362-.17-.823-.443-1.028-.615-.45-.363-.88-.393-1.175-.08-.313.343-.245.665.225 1.13 1.087 1.078 3.134 1.653 4.838 1.36zm-2.6-3.487c-.284-.373.268-.896.52-1.206s.7-.74.7-.74l-3.482.03c-3.066 0-3.193.062-3.4-.13a.79.79 0 01-.01-1.068c.196-.18.42-.122 3.4-.152h3.48l-.76-.8c-.288-.28-.645-.54-.596-.78a.94.94 0 01.274-.443c.42-.373.627-.252 1.96 1.098 1.068 1.087 1.256 1.33 1.256 1.59s-.196.504-1.254 1.592c-1.068 1.098-1.293 1.28-1.557 1.28-.215 0-.372-.08-.52-.272z"
  })));
}

export default SvgLoginIcon;